import { Injectable } from "@angular/core";

@Injectable()
export class ThemesService {
  styleTag: any;
  defaultTheme = "H";

  constructor() {
    this.createStyle();
    this.setTheme(this.defaultTheme);
  }

  private createStyle() {
    const head = document.head || document.getElementsByTagName("head")[0];
    this.styleTag = document.createElement("style");
    this.styleTag.type = "text/css";
    this.styleTag.id = "appthemes";
    head.appendChild(this.styleTag);
  }

  setTheme(name) {
    switch (name) {
      // case 'A':
      //     this.injectStylesheet(themeA);
      //     break;
      // case 'B':
      //     this.injectStylesheet(themeB);
      //     break;
      // case 'C':
      //     this.injectStylesheet(themeC);
      //     break;
      // case 'D':
      //     this.injectStylesheet(themeD);
      //     break;
      // case 'E':
      //     this.injectStylesheet(themeE);
      //     break;
      // case 'F':
      //     this.injectStylesheet(themeF);
      //     break;
      // case 'G':
      //     this.injectStylesheet(themeG);
      //     break;
      case "H":
        //this.injectStylesheet(themeHXA);
        break;
    }
  }

  injectStylesheet(css) {
    this.styleTag.innerHTML = css.default;
  }

  getDefaultTheme() {
    return this.defaultTheme;
  }
}
